import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { KnowledgeBaseView } from '../components/views/knowledgebaseView'
import { ChatbotView } from '../components/views/chatbot'

function Chatbot() {
    return (
        <div className="chatbot">
            <Sidebar />
            <MainView>
                <ChatbotView />
            </MainView>
        </div>
    )
}

export default Chatbot
